/* ==========================================================
   VAYSIN — theme.js
   Handles: mobile nav, search flyout, cart drawer, quantity
   steppers, FAQ accordions, product gallery/tabs, tracking bar
   ========================================================== */
document.addEventListener('DOMContentLoaded', function () {

  /* ---------- helpers ---------- */
  const qs = (s, ctx) => (ctx || document).querySelector(s);
  const qsa = (s, ctx) => Array.from((ctx || document).querySelectorAll(s));

  /* ---------- Mobile nav drawer ---------- */
  const mobileNav = qs('[data-mobile-nav]');
  const mobileNavOverlay = qs('[data-mobile-nav-overlay]');
  qsa('[data-mobile-nav-toggle]').forEach(btn => {
    btn.addEventListener('click', () => {
      mobileNav && mobileNav.classList.add('is-open');
      mobileNavOverlay && mobileNavOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  });
  qsa('[data-mobile-nav-close]').forEach(btn => {
    btn.addEventListener('click', closeMobileNav);
  });
  mobileNavOverlay && mobileNavOverlay.addEventListener('click', closeMobileNav);
  function closeMobileNav() {
    mobileNav && mobileNav.classList.remove('is-open');
    mobileNavOverlay && mobileNavOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  /* ---------- Search flyout ---------- */
  const searchFlyout = qs('[data-search-flyout]');
  qsa('[data-search-toggle]').forEach(btn => {
    btn.addEventListener('click', () => {
      searchFlyout && searchFlyout.classList.add('is-open');
      const input = searchFlyout && searchFlyout.querySelector('input');
      input && setTimeout(() => input.focus(), 150);
    });
  });
  qsa('[data-search-close]').forEach(btn => {
    btn.addEventListener('click', () => searchFlyout && searchFlyout.classList.remove('is-open'));
  });
  searchFlyout && searchFlyout.addEventListener('click', (e) => {
    if (e.target === searchFlyout) searchFlyout.classList.remove('is-open');
  });

  /* ---------- Cart drawer ---------- */
  const cartDrawer = qs('[data-cart-drawer]');
  const cartOverlay = qs('[data-cart-overlay]');
  function openCart() {
    cartDrawer && cartDrawer.classList.add('is-open');
    cartOverlay && cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    cartDrawer && cartDrawer.classList.remove('is-open');
    cartOverlay && cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  qsa('[data-cart-toggle]').forEach(btn => btn.addEventListener('click', openCart));
  qsa('[data-cart-close]').forEach(btn => btn.addEventListener('click', closeCart));
  cartOverlay && cartOverlay.addEventListener('click', closeCart);

  /* Add-to-cart via AJAX API so the drawer can open with a live count.
     A submit button named "checkout" (Buy it now) adds the item then
     redirects straight to checkout instead of opening the cart drawer. */
  qsa('[data-add-to-cart]').forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const isBuyNow = e.submitter && e.submitter.name === 'checkout';
      const formData = new FormData(form);
      formData.delete('checkout');
      const submitBtn = e.submitter || form.querySelector('[type="submit"]');
      if (submitBtn) { submitBtn.disabled = true; submitBtn.dataset.originalText = submitBtn.textContent; submitBtn.textContent = isBuyNow ? 'Redirecting…' : 'Adding…'; }
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(r => r.json())
        .then(() => {
          if (isBuyNow) {
            window.location.href = '/checkout';
            return;
          }
          return refreshCart().then(() => openCart());
        })
        .catch(() => {})
        .finally(() => {
          if (submitBtn && !isBuyNow) { submitBtn.disabled = false; submitBtn.textContent = submitBtn.dataset.originalText; }
        });
    });
  });

  function refreshCart() {
    return fetch('/cart.js').then(r => r.json()).then(cart => {
      qsa('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.style.display = cart.item_count ? 'flex' : 'none'; });
      return cart;
    });
  }

  /* ---------- Quantity steppers (cart + product) ---------- */
  qsa('[data-qty-selector]').forEach(sel => {
    const input = sel.querySelector('input');
    const minus = sel.querySelector('[data-qty-minus]');
    const plus = sel.querySelector('[data-qty-plus]');
    minus && minus.addEventListener('click', () => {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.dispatchEvent(new Event('change'));
    });
    plus && plus.addEventListener('click', () => {
      input.value = (parseInt(input.value, 10) || 1) + 1;
      input.dispatchEvent(new Event('change'));
    });
  });

  /* ---------- Product option swatches ---------- */
  qsa('[data-option-group]').forEach(group => {
    const label = group.querySelector('[data-selected-value]');
    qsa('.swatch', group).forEach(sw => {
      sw.addEventListener('click', () => {
        qsa('.swatch', group).forEach(s => s.classList.remove('is-active'));
        sw.classList.add('is-active');
        if (label) label.textContent = sw.textContent.trim();
      });
    });
  });

  /* ---------- Product gallery thumbs ---------- */
  const galleryMain = qs('[data-gallery-main] img');
  qsa('[data-gallery-thumb]').forEach(thumb => {
    thumb.addEventListener('click', () => {
      qsa('[data-gallery-thumb]').forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      if (galleryMain) galleryMain.src = thumb.dataset.fullImage || thumb.querySelector('img').src;
    });
  });

  /* ---------- Product tabs ---------- */
  qsa('[data-tabs]').forEach(tabWrap => {
    const buttons = qsa('[data-tab-btn]', tabWrap);
    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        buttons.forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        qsa('[data-tab-panel]', tabWrap).forEach(p => p.style.display = 'none');
        const target = qs('[data-tab-panel="' + btn.dataset.tabBtn + '"]', tabWrap);
        target && (target.style.display = 'block');
      });
    });
  });

  /* ---------- FAQ / accordions (shared: faq, product meta) ---------- */
  qsa('[data-accordion-item]').forEach(item => {
    const trigger = item.querySelector('[data-accordion-trigger]');
    const panel = item.querySelector('[data-accordion-panel]');
    trigger && trigger.addEventListener('click', () => {
      const isOpen = item.classList.contains('is-open');
      item.classList.toggle('is-open');
      panel.style.maxHeight = isOpen ? null : panel.scrollHeight + 'px';
    });
  });

  /* ---------- Pincode / delivery availability checker ---------- */
  qsa('[data-pincode-checker]').forEach(widget => {
    const form = widget.querySelector('[data-pincode-form]');
    const input = widget.querySelector('[data-pincode-input]');
    const result = widget.querySelector('[data-pincode-result]');
    if (!form || !input || !result) return;

    const excluded = (widget.dataset.excluded || '')
      .split(',').map(s => s.trim()).filter(Boolean);
    const metroPrefixes = (widget.dataset.metroPrefixes || '')
      .split(',').map(s => s.trim()).filter(Boolean);
    const estimateMetro = widget.dataset.estimateMetro || '2-4 business days';
    const estimateOther = widget.dataset.estimateOther || '4-7 business days';

    function setResult(state, message) {
      result.className = 'pincode-check-result is-visible is-' + state;
      const iconMarkup = state === 'available'
        ? '<svg class="icon" viewBox="0 0 24 24"><path d="M5 13l4 4 10-10"/></svg>'
        : state === 'unavailable'
          ? '<svg class="icon" viewBox="0 0 24 24"><path d="M5 5l14 14M19 5L5 19"/></svg>'
          : '<svg class="icon" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M12 8v5M12 16h.01"/></svg>';
      result.innerHTML = iconMarkup + '<span>' + message + '</span>';
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const code = (input.value || '').trim();

      if (!/^[1-9][0-9]{5}$/.test(code)) {
        setResult('error', 'Enter a valid 6-digit pincode.');
        return;
      }
      if (excluded.indexOf(code) !== -1) {
        setResult('unavailable', 'We do not currently deliver to ' + code + '. Reach us at help@vaysin.com and we will help however we can.');
        return;
      }
      const prefix = code.slice(0, 3);
      const isMetro = metroPrefixes.indexOf(prefix) !== -1;
      setResult('available', 'Delivers to ' + code + '. Estimated arrival: ' + (isMetro ? estimateMetro : estimateOther) + '.');
    });
  });

  /* ---------- Header shrink / hide-on-scroll shadow ---------- */
  const header = qs('.site-header');
  let lastY = window.scrollY;
  window.addEventListener('scroll', () => {
    if (!header) return;
    header.style.boxShadow = window.scrollY > 8 ? '0 2px 20px rgba(11,10,12,0.06)' : 'none';
    lastY = window.scrollY;
  }, { passive: true });

  /* ---------- Video play button ---------- */
  qsa('[data-video-play]').forEach(btn => {
    btn.addEventListener('click', () => {
      const wrap = btn.closest('[data-video-wrap]');
      const video = wrap && wrap.querySelector('video');
      if (video) {
        video.play();
        video.setAttribute('controls', 'true');
        btn.style.display = 'none';
      }
    });
  });

  /* ---------- Newsletter / contact forms: basic client feedback ---------- */
  qsa('[data-inline-form]').forEach(form => {
    form.addEventListener('submit', () => {
      const btn = form.querySelector('[type="submit"]');
      if (btn) { btn.disabled = true; btn.textContent = 'Submitting…'; }
    });
  });

  /* ---------- Wishlist toggle (local, visual only) ---------- */
  qsa('[data-wishlist-btn]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      btn.classList.toggle('is-active');
    });
  });

});
